import { render, staticRenderFns } from "./EditQuestionGroup.vue?vue&type=template&id=83dc4246"
import script from "./EditQuestionGroup.vue?vue&type=script&lang=js"
export * from "./EditQuestionGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports